// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aBIf","content":"styles_content__3H_yq"};